import AppIcon from "@/app/components/atomic/AppIcon";

export default function ArgumentsSection({globaleNotation}: { globaleNotation: number }) {

    const argumentsList = [
        {
            title: "Gain de temps",
            desc: "Comparez en 2min, votre expert dédié s’occupe de tout de A à Z.",
            icon: "fa-alarm-clock",
        },
        {
            title: "Économie d'argent",
            desc: "On vous fait économiser jusqu’à 18 000 €",
            icon: "fa-euro",
        },
        {
            title: `${globaleNotation}/5 sur Avis Vérifiés`,
            desc: "Réassurez-moi est le courtier en ligne le mieux noté du marché",
            icon: "fa-star",
        },
    ]
    return (
        <div className="flex md:flex-row flex-col gap-4 md:items-center justify-center pt-20">
            {argumentsList.map((argument) => (
                <div key={argument.title} className="flex flex-col gap-2 md:w-1/3">
                    <div className="flex">
                        <div className="w-[40px] h-[32px] rounded-full bg-white flex items-center justify-center shrink-0">
                            <AppIcon
                                iconClassName={argument.icon}
                                type="solid"
                                size="lg"
                                className="text-deep-pink"
                            />
                        </div>

                        <div>
                            <h3 className="font-semibold bg-rm-blue-deep text-white title-look whitespace-nowrap">{argument.title}</h3>
                        </div>
                    </div>

                    <p className="whitespace-pre-line">
                        {argument.desc}
                    </p>
                </div>
            ))}
        </div>
    )
}
